import React, { Component } from 'react';
import { Tabs, Tab } from 'react-bootstrap';

import './tab-selector.css';

class TabSelector extends Component {
  constructor(props) {
    super(props);

    this.state = { activeKey: this.props.active };
  }

  setKey = (key) => {
    this.setState({ activeKey: key });
  }

  componentWillReceiveProps(nextProps) {
    if (window.location.hash === "#myrewards") {
      this.setKey("my-rewards");
      window.location.hash = "#my-incentives-and-rewards";
    }
  }

  render() {
    return (
      <div className="tab-selector container">
        <div>
          <h2>{this.props.title}</h2>
        </div>
        <Tabs
          activeKey={this.state.activeKey}
          onSelect={(key) => this.setKey(key)}
        >
          {this.props.data.length > 0 &&
              this.props.data.map((tab, index) => (
                <Tab key={index} eventKey={tab.key} title={tab.name}>
                  {tab.body}
                </Tab>
              )
            )
          }
        </Tabs>
      </div>
    );
  }
}

export default TabSelector;



// WEBPACK FOOTER //
// ./src/components/common/tab-selector/tab-selector.jsx